module.exports = __webpack_public_path__ + "assets/img/bg-contato-mb.jpg";